<template>
  <div class="div-area-time" ref="areaWrap">
    <el-form :model="timeForm" ref="timeForm">
      <draggable
        class="list-group-wrapper"
        element="div"
        v-model="timeForm.markerData"
        :move="onMove"
        @end="endMove"
        draggable=".groupDraggable"
        v-bind="dragOptions()"
      >
        <transition-group name="no" class="list-group" tag="div">
          <div
            class="area-item"
            v-for="(item, index) in timeForm.markerData"
            :key="'marker' + index"
            :class="item.nodeType === 5 ? 'undraggableCls' : 'groupDraggable'"
          >
            <!-- 序号下面的线 -->
            <div
              v-if="item.nodeType !== 5"
              class="el-timeline-item__tail"
            ></div>
            <!-- 两个区域之间的添加区域按钮 -->
            <div
              v-if="item.nodeType !== 5"
              class="el-timeline-item__add e6-icon-add_line"
              @click="handleAreaSelect(index)"
            ></div>
            <!-- 区域title -->
            <div :class="!formType ? 'item-title item-bottom' : 'item-title'">
              <!-- 序号 -->
              <span class="sort-icon">
                <em>{{ index + 1 }}</em>
              </span>
              <!-- 区域名称 -->
              <span class="area-name" ref="areaItem" :title="item.areaName">{{
                item.areaName
              }}</span>
              <!-- 返程点标识 -->
              <el-tag effect="dark" v-if="item.nodeType === 5">返</el-tag>
              <!-- 删除按钮 -->
              <span
                class="e6-icon-clear_line"
                @click="delNode(index, item.nodeType)"
              ></span>
            </div>
            <div class="item_time_point" v-if="formType === 1">
              <!-- v-if="index > 0" 
                :rules="[
                  {
                    required: true,
                    message: '请选择时间',
                    trigger: 'change'
                  }
                ]"-->
              <el-form-item
                label="到达时间"
                :class="
                  index === timeForm.markerData.length - 1 &&
                  item.nodeType === 5
                    ? 'arrive-time'
                    : ''
                "
                :prop="'markerData.' + index + '.arriveTime'"
                :rules="[
                  {
                    validator: validateFormItem,
                    trigger: 'change'
                  }
                ]"
              >
                <el-time-picker
                  v-model="item.arriveTime"
                  popper-class="special--full"
                  placeholder="请选择"
                  value-format="HH:mm:ss"
                  clearable
                >
                </el-time-picker>
              </el-form-item>
              <!-- v-if="!(index > 0 && index === timeForm.markerData.length - 1)"
                  :rules="[
                  {
                    required: true,
                    message: '请选择时间',
                    trigger: 'change'
                  }
                ]" -->
              <!--                 
                :rules="[
                  {
                    validator: validateFormItem,
                    trigger: 'change'
                  }
                ]" -->
              <el-form-item
                label="离开时间"
                v-if="item.nodeType !== 5"
                :class="index === 0 ? 'leave-time' : ''"
                :prop="'markerData.' + index + '.leaveTime'"
                :rules="[
                  {
                    validator: validateFormItem,
                    trigger: 'change'
                  }
                ]"
              >
                <el-time-picker
                  v-model="item.leaveTime"
                  popper-class="special--full"
                  placeholder="请选择"
                  value-format="HH:mm:ss"
                  clearable
                >
                </el-time-picker>
              </el-form-item>
              <el-form-item
                label="是否跨天"
                v-if="index > 0"
                :prop="'markerData.' + index + '.overDay'"
                :rules="[
                  {
                    validator: (rule, value, callback) =>
                      validatorChooseOverDay(rule, value, callback, index),
                    trigger: 'change'
                  }
                ]"
              >
                <el-radio-group
                  v-model="item.overDay"
                  @change="changeOverDay(item, index)"
                >
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item
                class="over-num"
                v-if="item.overDay > 0 && index > 0"
                :prop="'markerData.' + index + '.daySpanNum'"
                :rules="[
                  { validator: validatorNum, trigger: 'blur' },
                  {
                    validator: (rule, value, callback) =>
                      validatorOverDay(rule, value, callback, index),
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  @change="handleValidForm"
                  v-model.trim="item.daySpanNum"
                  maxlength="10"
                  ><span class="suffix_unit" slot="suffix">天</span></el-input
                >
              </el-form-item>
            </div>
            <div class="item_time_interval" v-if="formType === 2">
              <div class="transport-duration">
                <el-form-item
                  label="到下一节点运输时长"
                  v-if="
                    !(index > 0 && index === timeForm.markerData.length - 1)
                  "
                  :prop="'markerData.' + index + '.transportDuration'"
                  :rules="[
                    {
                      required: true,
                      message: '请输入',
                      trigger: 'blur'
                    },
                    { validator: validatorNum, trigger: 'blur' }
                  ]"
                >
                  <el-input v-model.trim="item.transportDuration" maxlength="10"
                    ><span class="suffix_unit" slot="suffix"
                      >分钟</span
                    ></el-input
                  >
                </el-form-item>
              </div>
              <div
                :class="
                  index === timeForm.markerData.length - 1
                    ? 'stay-duration'
                    : ''
                "
              >
                <el-form-item
                  label="停留时长"
                  v-if="index > 0"
                  :prop="'markerData.' + index + '.stayDuration'"
                  :rules="[
                    {
                      required: true,
                      message: '请输入',
                      trigger: 'blur'
                    },
                    { validator: validatorNum, trigger: 'blur' }
                  ]"
                >
                  <el-input v-model.trim="item.stayDuration" maxlength="10"
                    ><span class="suffix_unit" slot="suffix"
                      >分钟</span
                    ></el-input
                  >
                </el-form-item>
              </div>
            </div>
          </div>
        </transition-group>
      </draggable>
      <slot name="backPoint"></slot>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    choosePointData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    formType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      timeForm: {
        markerData: []
      }
    };
  },
  watch: {
    choosePointData: {
      handler() {
        let data = _.cloneDeep(this.choosePointData);
        let newData = data.map(item => {
          let itemTmp = _.cloneDeep(item);
          // 判断当前点是否在右侧面板中存在，避免面板信息因地图批量删除添加操作被清空
          let marker = this.timeForm.markerData.find(v => {
            return v.uniqId === item.uniqId; // 这里通过手动添加的UNIQId查找
          });
          if (marker) {
            // 这里添加深克隆，修复之前会造成的数据耦合的bug（修改相同两条数据其中一条，会影响其他）
            itemTmp = _.cloneDeep(marker);
          } else if (this.formType === 1 && !item.daySpanNum) {
            itemTmp.overDay = 0;
            itemTmp.daySpanNum = 0;
          }
          return itemTmp;
        });
        this.timeForm.markerData = newData;
      },
      deep: true
    }
  },
  methods: {
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.disabled) &&
        !draggedElement.disabled
      );
    },
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
        preventOnFilter: true
      };
    },
    endMove() {
      this.$emit("change", this.timeForm.markerData);
    },
    delNode(index, nodeType) {
      this.$emit("delete", index, nodeType);
    },
    handleAreaSelect(index) {
      this.$emit("addAreaSplice", index);
    },
    changeOverDay(item, index) {
      // 选择跨天时判断
      if (item.overDay === 1 && index > 0) {
        // 当前一时间点跨天时，当前时间点跨天应大于等于前一时段
        if (this.timeForm.markerData[index - 1].overDay === 1) {
          item.daySpanNum = this.timeForm.markerData[index - 1].daySpanNum;
        } else {
          // 跨天默认为填充1天
          item.daySpanNum = 1;
        }
        // 当前时间点跨天后，之后所有时间点应当跨天,循环处理当前时间点跨天后的所有时间点跨天
        for (let i = index + 1; i < this.timeForm.markerData.length; i++) {
          let point = this.timeForm.markerData[i];
          let beforePoint = this.timeForm.markerData[i - 1]; // 前一个时间点
          // 当前下标跨天数小于前一个时间点跨天数时，修改为等于前一个时间点
          if (point.daySpanNum < beforePoint.daySpanNum) {
            this.timeForm.markerData[i].daySpanNum = beforePoint.daySpanNum;
            this.timeForm.markerData[i].overDay = 1;
          }
        }
      } else {
        item.daySpanNum = 0;
      }
      this.$refs.timeForm.validate();
    },
    handleValidForm() {
      this.$refs.timeForm.validate();
    },
    // 修改跨天数(TODO:暂不使用input失焦时改变其他选框跨天值)
    changeDaySpanNum(day, index) {
      // 当前时间点跨天后，之后所有时间点应当跨天,循环处理当前时间点跨天后的所有时间点跨天
      for (let i = index + 1; i < this.timeForm.markerData.length; i++) {
        let point = this.timeForm.markerData[i];
        let beforePoint = this.timeForm.markerData[i - 1]; // 前一个时间点
        // 当前下标跨天数小于前一个时间点跨天数时，修改为等于前一个时间点
        if (point.daySpanNum < beforePoint.daySpanNum) {
          this.timeForm.markerData[i].daySpanNum = beforePoint.daySpanNum;
          this.timeForm.markerData[i].overDay = 1;
        }
      }
    },
    validatorNum(rule, value, callback) {
      let bool = /^([1-9]\d*)$/.test(value);
      if ((value !== 0) & !value) {
        callback(new Error("请输入"));
      } else if (!bool) {
        callback(new Error("请输入正整数"));
      } else {
        callback();
      }
    },
    // 跨天选择校验
    validatorChooseOverDay(rule, value, callback, index) {
      if (
        index > 0 &&
        value === 0 &&
        this.timeForm.markerData[index - 1].overDay === 1
      ) {
        callback(new Error("跨天数选择有误"));
        this.$message.error("请检查节点跨天数填写是否正确");
      } else {
        callback();
      }
    },
    validatorOverDay(rule, value, callback, index) {
      if (
        index > 0 &&
        value > 0 &&
        this.timeForm.markerData[index - 1].overDay === 1
      ) {
        let beforeItem = this.timeForm.markerData[index - 1];
        if (beforeItem.daySpanNum > value) {
          callback(new Error("跨天数填写有误"));
          this.$message.error("请检查节点跨天数填写是否正确");
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
    // 改变时间默认跨天处理(TODO:暂时废弃)
    changeTimeOverDay(item, index, type) {
      let Day = moment().format("YYYY-MM-DD");
      let startAreaTime = this.timeForm.markerData[0].leaveTime
        ? moment(Day + " " + this.timeForm.markerData[0].leaveTime).valueOf()
        : "";
      if (index === 0 && type === "leave") {
        for (let i = 1; i < this.timeForm.markerData.length; i++) {
          let time = this.timeForm.markerData[i];
          if (time.arriveTime) {
            let timeArrive = moment(Day + " " + time.arriveTime).valueOf();
            if (timeArrive < startAreaTime && !item.overDay) {
              this.timeForm.markerData[i].overDay = 1;
              this.changeOverDay(this.timeForm.markerData[i]);
            }
          }
        }
      } else if (type === "arrive") {
        let itemArrive = moment(Day + " " + item.arriveTime).valueOf();
        if (startAreaTime && itemArrive < startAreaTime && !item.overDay) {
          item.overDay = 1;
          this.changeOverDay(item);
        }
      }
    },
    /* ***************************
     * 校验表单项
     * 1. 只比较相邻两项的预计离开时间不能早于到达时间
     * 2. 不填则不校验
     * ***************************/
    validateFormItem(rule, value, callback) {
      if (!value) return callback(); // 不校验

      const idx = Number(rule.field.replace(/\D/gi, "")); // 当前的序号
      const areaList = this.timeForm.markerData; // 区域列表
      const isArriveItem = rule.field.includes("arriveTime"); // 是否是到达时间项

      if (idx === 0 && isArriveItem) return callback(); // 不校验非数字和不校验第一条的到达时间项
      // 处理跨天数据
      let prevOverDay = 0,
        overDay = areaList[idx].overDay ? Number(areaList[idx].daySpanNum) : 0;
      // 上一个项用来比较的值, 错误的提示信息
      let prevVal, errMsg;

      if (isArriveItem) {
        prevOverDay = areaList[idx - 1].overDay
          ? Number(areaList[idx - 1].daySpanNum)
          : 0;
        prevVal = areaList[idx - 1].leaveTime;
        errMsg = "到达时间不能早于离开时间";
      }
      // else {
      //   prevOverDay = areaList[idx].overDay
      //     ? Number(areaList[idx].daySpanNum)
      //     : 0;
      //   prevVal = areaList[idx].arriveTime;
      //   errMsg = "离开时间不能早于到达时间";
      // }

      if (!prevVal) return callback(); // 不校验

      if (prevOverDay > overDay || (prevOverDay === overDay && prevVal > value))
        callback(errMsg);
      else callback();
    }
  }
};
</script>
<style lang="scss" scoped>
@import "e6-base-carrier-3.0/styles/variables.scss";
.div-area-time {
  font-size: 12px;
  .area-item {
    cursor: move;
    position: relative;
    height: 90px;
    .area-name {
      width: calc(100% - 115px);
      white-space: nowrap;
      overflow: hidden;
      display: inline-block;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
    .el-timeline-item__tail {
      position: absolute;
      left: 15px;
      top: 30px;
      border-left: 1px solid #e4e7ed;
    }
    .el-timeline-item__add {
      position: absolute;
      left: 5px;
      top: 58%;
      width: 20px;
      height: 20px;
      border: 1px dashed #c1c1c1;
      border-radius: 3px;
      text-align: center;
      line-height: 20px;
      color: #c1c1c1;
      background: #fff;
      cursor: pointer;
      &:hover {
        border: 1px dashed #1889fd;
        color: #1889fd;
        background: #d8e7f7;
      }
    }
    &:last-child {
      .el-timeline-item__tail {
        position: absolute;
        left: 15px;
        top: 30px;
        height: 50%;
        border-left: 1px solid #e4e7ed;
      }
    }
  }
  .undraggableCls {
    cursor: auto;
  }
  .item-title {
    background-color: $--color-theme-first-light-9-2;
    border-radius: 9999px;
    margin-bottom: 10px;
    color: #48494c;
    &.item-bottom {
      margin-bottom: 20px;
    }
    .sort-icon {
      display: inline-block;
      width: 30px;
      height: 30px;
      line-height: 30px;
      background-color: #1889fd;
      text-align: center;
      color: #fff;
      border-radius: 100%;
      margin-right: 10px;
      font-size: 14px;
    }
    em {
      font-style: normal;
    }
    .e6-icon-clear_line {
      font-size: 18px;
      color: $--color-theme-first;
      float: right;
      line-height: 30px;
      margin-right: 20px;
      cursor: pointer;
    }
  }
  .item_time_point {
    clear: both;
    overflow: hidden;
    margin-bottom: 10px;
    margin-left: 26px;
    /deep/ .el-form-item {
      .el-form-item__label {
        width: 75px !important;
        line-height: 32px;
      }
      .el-form-item__content {
        margin-left: 75px !important;
        .el-input__inner {
          padding-right: 15px;
        }
        .el-form-item__error {
          // position: static;
          white-space: nowrap;
        }
      }
      .el-date-editor.el-input {
        width: 95px;
      }
      .el-radio {
        margin-right: 15px;
        .el-radio__label {
          font-size: 12px;
        }
      }
      &.over-num {
        .el-form-item__content {
          width: 55px;
          margin-left: 0 !important;

          .el-form-item__error {
            word-break: keep-all;
            right: 0;
            left: auto;
          }
        }
      }
    }
  }
  .item_time_interval {
    clear: both;
    overflow: hidden;
    margin-bottom: 10px;
    /deep/ .el-form-item {
      .el-form-item__content {
        width: 105px;
        margin-left: 160px !important;
        .el-input__inner {
          padding-right: 15px;
        }
      }
      .el-form-item__label {
        width: 160px !important;
      }
    }
  }
  .hidden-item {
    visibility: hidden;
  }
  .stay-duration {
    margin-left: 265px;
  }

  .arrive-time {
    margin-right: 110px;
  }
  // .leave-time {
  //   margin-left: 110px;
  // }
}
</style>
